import type { ComponentType } from "react";
import type { Guide, GuideFrontmatter, HelpCategoryId } from "./types";

type MdxModule = {
  default: ComponentType<Record<string, unknown>>;
  frontmatter: GuideFrontmatter;
};

const modules = import.meta.glob<MdxModule>(
  "../../pages/help/content/guides/**/*.mdx",
  { eager: true },
);

function toGuide(mod: MdxModule): Guide {
  return { frontmatter: mod.frontmatter, Component: mod.default };
}

const guides: Guide[] = Object.values(modules)
  .map(toGuide)
  .sort((a, b) => a.frontmatter.order - b.frontmatter.order);

export function getAllGuides(): Guide[] {
  return guides;
}

export function getGuideBySlug(slug: string): Guide | undefined {
  return guides.find((g) => g.frontmatter.slug === slug);
}

export function getGuidesByCategory(category: HelpCategoryId): Guide[] {
  return guides.filter((g) => g.frontmatter.category === category);
}
